function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";

var Timer = /*#__PURE__*/function (_Component) {
  _inherits(Timer, _Component);

  var _super = _createSuper(Timer);

  function Timer(props) {
    var _this;

    _classCallCheck(this, Timer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      now: 0
    });

    _defineProperty(_assertThisInitialized(_this), "resetTimer", function () {
      _this.setState({
        time: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "startTimer", function () {
      _this.startTime = Date.now();
      _this.timer = setInterval(_this.tick, 1000);
    });

    _defineProperty(_assertThisInitialized(_this), "stopTimer", function () {
      clearInterval(_this.timer);
    });

    _defineProperty(_assertThisInitialized(_this), "tick", function () {
      _this.props.countDown ? _this.setState({
        time: _this.startTime - Date.now()
      }) : _this.setState({
        time: Date.now() - _this.startTime
      });
    });

    _defineProperty(_assertThisInitialized(_this), "convertTimeToString", function () {
      return "".concat(_this.convertTimeToMinutesString(), ":").concat(_this.convertTimeToSecondsString());
    });

    _defineProperty(_assertThisInitialized(_this), "convertTimeToMinutesString", function () {
      var minutes = _this.convertTimeToMinutes();

      minutes = minutes < 10 ? "0".concat(minutes) : "".concat(minutes);
      return "".concat(minutes);
    });

    _defineProperty(_assertThisInitialized(_this), "convertTimeToSecondsString", function () {
      var seconds = _this.convertTimeToSeconds();

      seconds = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
      return "".concat(seconds);
    });

    _defineProperty(_assertThisInitialized(_this), "convertTimeToSeconds", function () {
      var ms = _this.state.time;
      var seconds = Math.round(ms / 1000) % 60;
      return seconds;
    });

    _defineProperty(_assertThisInitialized(_this), "convertTimeToMinutes", function () {
      var seconds = Math.round(_this.state.time / 1000);
      var minutes = Math.floor(seconds / 60);
      return minutes;
    });

    _this.startTime = props.startTime;
    return _this;
  }

  _createClass(Timer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.tick(); // set the timer to 00:00
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.className
      }, /*#__PURE__*/React.createElement("span", {
        className: "minutes"
      }, this.convertTimeToMinutesString()), ":", /*#__PURE__*/React.createElement("span", {
        className: "seconds"
      }, this.convertTimeToSecondsString()));
    }
  }]);

  return Timer;
}(Component);

_defineProperty(Timer, "defaultProps", {
  startTime: Date.now(),
  className: "timer",
  countDown: null
});

export default Timer;